/* eslint-disable import/prefer-default-export */
import toastrError from 'src/helpers/toastr/toastrError';
import communicate from 'src/api/communicate';

export const REQUEST = 'LOAD_PASSING_GROUPS_REQUEST';
export const FAIL = 'LOAD_PASSING_GROUPS_FAIL';
export const SUCCESS = 'LOAD_PASSING_GROUPS_SUCCESS';

export const OPTIONS_SUCCESS = 'LOAD_PASSING_GROUPS_OPTIONS_SUCCESS';

const loadPassingGroupsRequest = () => ({ type: REQUEST });
const loadPassingGroupsFail = (err) => ({ type: FAIL, err });
const loadPassingGroupsSuccess = (passingGroups) => ({ type: SUCCESS, passingGroups });

const loadPassingGroupsOptionsSuccess = (options) => {
  const passingGroupsOptions = options.map(({ PassingGroupId, PassingGroupName }) => ({
    label: PassingGroupName,
    value: PassingGroupId.toString()
  }));
  return ({ type: OPTIONS_SUCCESS, passingGroupsOptions });
};

// OLD API, still used in Planner
export const loadPassingGroups = () => (dispatch) => {
  dispatch(loadPassingGroupsRequest());

  return communicate({ url: 'PassingGroups' })
    .then(({ data: { Data: passingGroups } }) => {
      dispatch(loadPassingGroupsSuccess(passingGroups));
      dispatch(loadPassingGroupsOptionsSuccess(passingGroups));
    })
    .catch((e) => {
      dispatch(loadPassingGroupsFail(e));
      toastrError(e);
    });
};
